import { gql } from '@apollo/client'

export const assignRoleToUser = gql`
  mutation AssignRoleToUser($data: AssignRoleToUserInput!) {
    assignRoleToUser(data: $data) {
      id
      userId
      roleId
      fundId
      scope
      createdAt
    }
  }
`

export const revokeRoleFromUser = gql`
  mutation RevokeRoleFromUser($userId: Int!, $roleId: Int!, $fundId: Int) {
    revokeRoleFromUser(userId: $userId, roleId: $roleId, fundId: $fundId)
  }
`

export const assignAdminPortal = gql`
  mutation AssignAdminPortal($userId: Int!, $portalName: String) {
    assignAdminPortal(userId: $userId, portalName: $portalName) {
      id
      userId
      portalName
      createdAt
      user {
        id
        email
        profile {
          firstName
          lastName
        }
      }
    }
  }
`
